import React from "react";
import CollapsableWrapper from "../CollapsableWrapper/CollapsableWrapper";
import BasicCompanyData from "../BasicCompanyData/BasicCompanyData";
import AddressData from "../AddressData/AddressData";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import OfficeAddress from "../OfficeAddress/OfficeAddress";
import BasicReviserData from "../BasicReviserData/BasicReviserData";
import AuditCompanyMember from "../AuditCompanyMember/AuditCompanyMember";
import AuditCompanyBoardMember from "../AuditCompanyBoardMember/AuditCompanyBoardMember";
import NetworkMembershipInfo from "../NetworkMembershipInfo/NetworkMembershipInfo";
import NamesAndAddressesNetworkList from "../NamesAndAddressesNetworkList/NamesAndAddressesNetworkList";
import RegistrationComponent from "../RegistrationComponent/RegistrationComponent";
import Dropdown from "../../UI/Dropdown/Dropdown";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import ContactInformationMultiple from "../ContactInformationMultiple/ContactInformationMultiple";
import "./EntryForm1.css";
import NameAndAddressData from "../NameAndAddressData/NameAndAddressData";
import InputComponent from "../../UI/InputComponent/InputComponent";
import { Spinner } from "react-bootstrap";
import MappedRegistrationComponent from "../MappedRegistrationComponent/MappedRegistrationComponent";
const EntryForm1 = (props) => {
  const { update } = props.parentState;
  const { officeAddress } = props.parentState.newFormData;
  const mappedOfficeAddress = officeAddress.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`office-address-collapse${index}`}
        clickText={`Adresa ureda ${
          officeAddress.length > 1 ? `(${index + 1})` : ""
        }`}
      >
        <OfficeAddress
          objData={{ group: "officeAddress" }}
          id={element.id}
          idZaBtn={index}
          {...props}
        />
      </CollapsableWrapper>
    );
  });

  const { basicReviserData } = props.parentState.newFormData;
  const mappedBasicReviserData = basicReviserData.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`basic-rev-data-collapsable${index}`}
        clickText={`Ovlašteni revizor ${
          element.ime && element.prezime ? `(${element.ime} ${element.prezime})` : "(Novi unos)"
        }`}
      >
        <BasicReviserData
          group="basicReviserData"
          disabled
          required
          id={element.id}
          idZaBtn = {index}
          handleFetch={props.getReviserDataByOib}
          {...props}
        />
      </CollapsableWrapper>
    );
  });

  const { contactInformation } = props.parentState.newFormData;

  const getContactInfo = contactInformation.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`contact-info-collapse${index}`}
        clickText={`Osoba za kontakt ${
          contactInformation.length > 1 ? `(${index + 1})` : ""
        } `}
      >
        <ContactInformationMultiple id={element.id} idZaBtn={index} {...props} />
      </CollapsableWrapper>
    );
  });


  const popuniZagraduAuditCompanyMember = (clan) =>{
    if(clan.oib){
      if(clan.ime && clan.prezime){
        if(clan.naziv) {
          return `(${clan.ime} ${clan.prezime} - ${clan.naziv})`
        }
        return `(${clan.ime} ${clan.prezime})`;
      }else if(clan.naziv){
        return `(${clan.naziv})`;
      }
    }
    return "(Novi unos)";
  }

  const { auditCompanyMember } = props.parentState.newFormData;
  const mappedAuditCompanyMember = auditCompanyMember.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`audit-company-member-collapse${index}`}
        clickText={`Član/dioničar revizorskog društva  ${popuniZagraduAuditCompanyMember(element)} `}
      >
        <AuditCompanyMember oibRequired id={element.id} idZaBtn={index} {...props} required />
      </CollapsableWrapper>
    );
  });

  const { auditCompanyBoardMember } = props.parentState.newFormData;
  const mappedAuditCompanyBoardMember = auditCompanyBoardMember.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`audit-company-board-member${index}`}
          clickText={`Član uprave ili upravnog odbora revizorskog društva ${
            element.ime && element.prezime ? `(${element.ime} ${element.prezime})` : "(Novi unos)"
          } `}
        >
          <AuditCompanyBoardMember id={element.id} idZaBtn={index} {...props} required />
        </CollapsableWrapper>
      );
    }
  );

  const { supervisoryAuthority } = props.parentState.newFormData;
  const mappedWorkingSupervisoryAuthority = supervisoryAuthority.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`supervisory-authority-collapse${index}`}
          clickText={`Nadležna tijela država članica odgovorna  za nadzor osiguranja kvalitete rada i nadzor ovlaštenih revizora i revizorskih društava ${
            supervisoryAuthority.length > 1 ? `(${index + 1})` : ""
          } `}
        >
          <NameAndAddressData
            onChange={props.mappedUserInputHandler}
            id={element.id}
            idZaBtn={index}
            group={"supervisoryAuthority"}
            {...props}
          />
        </CollapsableWrapper>
      );
    }
  );

  const { memberInfo } = props.parentState.newFormData;
  const mappedMemberInfo = memberInfo.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`member-info-collapse${index}`}
        clickText={`Popis naziva i adresa društava članova i povezanih društava ${
          memberInfo.length > 1 ? `(${index + 1})` : ""
        }`}
      >
        <NamesAndAddressesNetworkList
          required
          group={"memberInfo"}
          {...props}
          id={element.id}
          idZaBtn={index}
        />
      </CollapsableWrapper>
    );
  });

  const { auditCompanyRegistration } = props.parentState.newFormData;
  const mappedAuditCompanyRegistration = auditCompanyRegistration.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`audit-company-registration${index}`}
          clickText={`Registracije revizorskog društva kod nadležnog tijela drugih država članica ${
            auditCompanyRegistration.length > 1 ? `(${index + 1})` : ""
          }`}
        >
          <MappedRegistrationComponent
            {...props}
            regId={"audit-comp-reg"}
            id={element.id}
            idZaBtn={index}
            onChange={props.mappedUserInputHandler}
            inputValue={props.parentState.newFormData.auditCompanyRegistration}
            group="auditCompanyRegistration"
          />
        </CollapsableWrapper>
      );
    }
  );

  const { auditCompanyRegistrationForeign } = props.parentState.newFormData;

  const mappedAuditCompanyRegistrationForeign =
    auditCompanyRegistrationForeign.map((element, index) => {
      return (
        <CollapsableWrapper
          key={`mapped-audit-company-registration-foreign${index}`}
          clickText={`Registracije u drugoj državi članici revizorskog društva kao subjekt za obavljanje revizije u trećoj zemlji ${
            auditCompanyRegistrationForeign.length > 1 ? `(${index + 1})` : ""
          }`}
        >
          <MappedRegistrationComponent
            {...props}
            id={element.id}
            idZaBtn={index}
            onChange={props.mappedUserInputHandler}
            inputValue={
              props.parentState.newFormData.auditCompanyRegistrationForeign
            }
            group="auditCompanyRegistrationForeign"
          />
        </CollapsableWrapper>
      );
    });

  const legalFormsOptions = props.parentState.legalForms.map((element) => {
    return (
      <option key={element.sifPOblika} value={element.sifPOblika}>
        {element.opisPOblika}
      </option>
    );
  });

  const { userData } = props.parentState.newFormData;

  const { legalForms } = props.parentState;

  const disableCounty = props.parentState.newFormData.address.sifDrzave
    ? false
    : true;
  const disableCity = props.parentState.newFormData.address.sifZupanije
    ? false
    : true;
  const disableDistrict = props.parentState.newFormData.address.sifGrdOpc
    ? false
    : true;

  return (
    <>
      <CollapsableWrapper clickText="Osnovni podaci">
        <BasicCompanyData
          disabled={
            props.parentState.newFormData.oznDokumenta.oznDokumenta !== null &&
            props.parentState.update &&
            props.parentState.newFormData.userData.oznAkt == 1
          }
          required
          {...props}
        />

        <AddressData
          requiredKbr
          requiredBrPoste
          permitDateLabel={"Datum odobrenja za rad"}
          permitNumberLabel={"Broj odobrenja za rad"}
          required
          requiredRegistration
          disableDistrict={disableDistrict}
          disableCity={disableCity}
          disableCounty={disableCounty}
          {...props}
        >
          <Dropdown
            style={
              props.parentState.error && userData.sifPOblika.length < 1 && "red"
            }
            label={"Pravni oblik*"}
            hidden
            onChange={props.dropdownHandler}
            value={userData.sifPOblika}
            asProperty="select"
            map={legalFormsOptions}
            text="Odaberite pravni oblik"
          />
        </AddressData>
        {update && userData.sifPOblika == "999" && (
          <Row>
            <Col>
              <InputComponent
                style={
                  props.parentState.error &&
                  userData.sifPOblika == "999" &&
                  userData.opisPOblika.length < 1 &&
                  "red"
                }
                onChange={props.userInputHandler}
                objData={{ group: "userData" }}
                value={userData.opisPOblika}
                id="opisPOblika"
                controlLabel={"Opis pravnog oblika*"}
              />
            </Col>
            <Col></Col>
          </Row>
        )}

        {!update && (
          <Row>
            <Col className="col-lg-8 pravnioblik-style">
              <Dropdown
                style={
                  props.parentState.error &&
                  userData.sifPOblika.length < 1 &&
                  "red"
                }
                label={"Pravni oblik*"}
                hidden
                onChange={props.dropdownHandler}
                value={userData.sifPOblika}
                asProperty="select"
                map={legalFormsOptions}
                text="Odaberite pravni oblik"
              />
            </Col>
            <Col>
              {" "}
              {userData.sifPOblika == "999" && (
                <InputComponent
                  style={
                    props.parentState.error &&
                    userData.sifPOblika == "999" &&
                    userData.opisPOblika.length < 1 &&
                    "red"
                  }
                  onChange={props.userInputHandler}
                  objData={{ group: "userData" }}
                  value={userData.opisPOblika}
                  id="opisPOblika"
                  controlLabel={"Opis pravnog oblika*"}
                />
              )}
            </Col>
          </Row>
        )}
      </CollapsableWrapper>
      {getContactInfo}
      {mappedOfficeAddress}
      {mappedBasicReviserData}
      {mappedAuditCompanyMember}
      {mappedAuditCompanyBoardMember}
      <CollapsableWrapper clickText="Podaci o članstvu u mreži">
        <NetworkMembershipInfo required {...props} />
      </CollapsableWrapper>
      {mappedMemberInfo}
      {mappedAuditCompanyRegistration}
      {mappedAuditCompanyRegistrationForeign}

      {mappedWorkingSupervisoryAuthority}
      <div className="invert">
        {props.parentState.loader ? (
          <ButtonComponent disabled>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />{" "}
            Spremanje...
          </ButtonComponent>
        ) : (
          <ButtonComponent onClick={props.submitHandler}>
            {props.parentState.update ? "Spremi promjene" : "Unos u registar"}
          </ButtonComponent>
        )}
      </div>
    </>
  );
};

export default EntryForm1;
